<template>
	<div class="editable-cell">
		<div v-if="editable" class="editable-cell-input-wrapper">
			<a-input :value="value" @change="handleChange" @pressEnter="check" @blur="check" :type="type" />
			<a-icon type="check" class="editable-cell-icon-check" @click="check" />
		</div>
		<div v-else class="editable-cell-text-wrapper">
			{{ value || ' ' }}
			<a-icon type="edit" class="editable-cell-icon" @click="edit" />{{suffix}}
		</div>
	</div>
</template>
<script>
export default {
	props: {
		text: String,
		inpu2tpye: {
        	type: String,
        	default: 'number'
        },
		suffix: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			value: '',
			type:this.inpu2tpye,
			editable: false,
		};
	},
	methods: {
		handleChange(e) {
			const value = e.target.value;
			this.value = value;
		},
		check() {
			if (this.editable == true) {
				this.editable = false;
				this.$emit('change', this.value);
			} else {
				console.log("多次触发")
			}

		},
		edit() {
			this.editable = true;
		},
		valueChange(val) {
			this.value = val;
		}
	},
	watch: {
	    text: {
	        immediate: true,
	        handler (val) {
	            this.value = val;
	        },
	        deep: true
	    },
	}
};
</script>



// WEBPACK FOOTER //
// src/components/editableCell/editableCell.vue